export const environment = {
  clientID: '2',
};
